import { UPDATE_CURRENT, PREVSONG, NEXTSONG } from "./../constants/action_types";

export const update_current_album_and_song = (current_albums, album_index, song_index) => async (dispatch) =>
{
  try
  {
    dispatch({
      type: UPDATE_CURRENT, payload: {
        current_albums,
        album_index,
        song_index
      }
    });
  }
  catch (err)
  {
    console.trace(err);
  }
}

export const prev_song = () => async (dispatch) =>
{
  try
  {
    dispatch({ type: PREVSONG });
  }
  catch (err)
  {
    console.trace(err);
  }
}

export const next_song = () => async (dispatch) =>
{
  try
  {
    dispatch({ type: NEXTSONG });
  }
  catch (err)
  {
    console.trace(err);
  }
}